import { useEffect } from "react";

import { useAccount } from "#/store/wallet/account/account";

import { useWorker } from "../useWorker";

export function useTrackAccount() {
  const { account } = useAccount();
  const { worker, isWorkerReady } = useWorker();

  useEffect(() => {
    if (!isWorkerReady) return;

    worker!.setValues({ account: account ?? null });
  }, [account, worker, isWorkerReady]);
}
